import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const CardList = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '0.5rem',
  listStyle: 'none',
  margin: '0',
  padding: '0',
  [theme.breakpoints.up('md')]: {
    gap: '0.75rem'
  },
  [theme.breakpoints.up('lg')]: {
    gridAutoFlow: 'column',
    gridTemplateColumns: 'repeat(auto-fit, minmax(10rem, 1fr))'
  }
}));

export const CardItem = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2,
  alignItems: 'stretch'
}));
